export const version='1.1.0.0'; 



// WEBPACK FOOTER //
// ./version.ts